import React from 'react'
import { Row, Col, DivTextSlider, H2TextSlider, Img } from './styles';
import { Link } from '@reach/router';
import lineaCapilar from '../../images/lineaCapilar.png'
import lineaFacial from '../../images/lineaFacial.png'
import { ButtonLink } from '../ButtonLink';

export const LineasProduct = () => {
    return (
        <Row>
            <Col span={12} xs={{ span: 24  }} md={{ span: 12 }}>
                <Img src={lineaCapilar} preview={false} />
                <DivTextSlider>
                    <H2TextSlider>
                        Linea Capilar
                    </H2TextSlider>
                    <Link key={1} to={'/productos/lineas/1'}>
                        <ButtonLink text={'Ver Productos'}/>
                    </Link>
                </DivTextSlider>
            </Col>
            <Col span={12} xs={{ span: 24  }} md={{ span: 12 }}>
                <Img src={lineaFacial} preview={false} />
                <DivTextSlider>
                    <H2TextSlider>
                        Linea Facial
                    </H2TextSlider>
                    <Link key={2} to={'/productos/lineas/2'}>
                        <ButtonLink text={'Ver Productos'}/>
                    </Link>
                </DivTextSlider>
            </Col>
        </Row>
    )
}